export default __webpack_public_path__ + "static/media/T-Martbd.e0696afa.png";